import { css } from '@emotion/react';
import { atoms } from '@zapier/marketing-ui';
import { Icon } from '@zapier/zinnia-icons';
import { FC, ReactNode } from 'react';

const requirementStyle = css`
  display: flex;
  align-items: start;
  gap: 4px;
`;

type PasswordRequirementProps = {
  children: ReactNode;
  requirementIsSatisfied?: boolean;
  testId: string;
};

const PasswordRequirement: FC<PasswordRequirementProps> = ({
  children,
  requirementIsSatisfied,
  testId,
}) => {
  const name = requirementIsSatisfied ? 'formCheck' : 'formX';
  const color = requirementIsSatisfied
    ? 'StatusSuccessStrongest'
    : 'StatusErrorStrongest';

  return (
    <div data-testid={testId} css={requirementStyle}>
      <Icon name={name} color={color} size={20} />
      <p className={`${atoms.bodySM} ${atoms.textNeutral800}`}>{children}</p>
    </div>
  );
};

export default PasswordRequirement;
